<div class="flex flex-col h-full">
    <div class="flex items-center" id="page-header">
        <button mat-icon-button type="button" (click)="onGoHomeButtonClick()">
            <mat-icon>arrow_back_ios_new</mat-icon>
        </button>
        <h1>Set Debug Mode</h1>
    </div>

    <div id="scroll-content-container" class="flex-auto basis-0">
        <div style="padding: 1em" class="flex flex-col gap-8 items-start">
            <div id="rax-debug-key" class="flex flex-col sm:flex-row sm:gap-4">
                <div class="flex gap-4">
                    <mat-form-field class="rax-compact-form-field">
                        <input
                            matInput
                            type="text"
                            name="debugKeyValue"
                            [(ngModel)]="raxDebugKeyValue"
                            (ngModelChange)="onRaxDebugKeyValueNgModelChange()"
                            placeholder="Debug key"
                        />
                    </mat-form-field>
                    @if (raxDebugKeyIsSet()) {
                        <mat-icon>
                            @if (raxDebugKeyIsSaved()) {
                                check
                            } @else if (!raxDebugKeyValue()) {
                                close
                            }
                        </mat-icon>
                    } @else {
                        <mat-icon class="hidden! sm:inline-block!">horizontal_rule</mat-icon>
                    }
                </div>
                <div class="flex gap-4">
                    <button mat-flat-button type="button" (click)="onSetRaxDebugKeyButtonClick(raxDebugKeyValue())">Set debug key</button>
                    <button mat-stroked-button type="button" (click)="onClearRaxDebugKeyButtonClick()" [disabled]="!raxDebugKeyValue()">
                        Clear debug key
                    </button>
                </div>
            </div>

            <button mat-stroked-button type="button" (click)="onGoHomeButtonClick()">Ga verder</button>
        </div>
    </div>
</div>
